export default __webpack_public_path__ + "static/tc-2bcb2ad40ee656d634c810592481ecf0.png";